import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-4" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }

import ProductsList from '@/components/ProductsList.vue';
    import Api from '@/services/api';
    import { Product } from '@/services/types';
    import { Paginated } from '@/services/types/paginated';
    import { Store } from '@/services/types/store';
    import { defaultPaginated } from '@/utilities/helpers';
    import { ElIcon, ElMessage, ElMessageBox, ElPagination, ElSkeleton } from 'element-plus';
import { it } from 'node:test';
    import { onBeforeMount, ref } from 'vue';
    import { useRoute, useRouter } from 'vue-router';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'StoreView',
  setup(__props) {

    const route = useRoute()
    const router = useRouter()
    const {id} = route.params
    const store = ref<Store>()
    const loading = ref<boolean>(true)
    const search = ref<string>('')
    const updating = ref<boolean>(false)
    const products = ref<Paginated<Product>>(defaultPaginated)

    const getStore = async () => {
        updating.value = true
        const res = await Api.get('admin/stores/' + id)
        if (res.status == 200) {
            const data = res.data.store
            store.value = data
        } else if (res.status != 404) {
            ElMessageBox.alert('Ocorreu um erro ' + res.data.message, {type: "error"}).then(() => router.push('/products')).catch(() => router.push('/products'))
        }
        updating.value = false
    }

    const getProducts = async (q = '', page = 1) => {
        console.log("Okay")
        updating.value = true
        const res = await Api.get(`admin/stores/products/${id}?q=${q}&page=${page}`)
        if (res.status == 200) {
            products.value = res.data.products
            console.log(res.data.products)
        } else {
            ElMessageBox.alert('Ocorreu um erro ao buscar os dados')
        }

        updating.value = false
    }

    const approve = async (up = true) => {
        updating.value = true
        const res = await (up ? Api.post(`admin/stores/${id}`, {}):Api.delete(`admin/stores/${id}`))
        if (res.status != 200) {
            ElMessage.error({message: 'Ocorreu um erro ' + res.data.message ? res.data.message:''})
        } else {
            ElMessage.success({message: 'Actualizado com sucesso'})
            if (store.value) {
                store.value.approved_at = res.data.store.approved_at
            }
        }
        updating.value = false
    }

    const openProduct = (id: number | string) => {
        router.push('/products/' + id)
    }

    onBeforeMount(async () => {
        loading.value = true
        await getProducts()
        await getStore()

        loading.value = false
    })

return (_ctx: any,_cache: any) => {
  const _component_el_result = _resolveComponent("el-result")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_CircleCloseFilled = _resolveComponent("CircleCloseFilled")!
  const _component_Select = _resolveComponent("Select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ElInput = _resolveComponent("ElInput")!
  const _component_Search = _resolveComponent("Search")!
  const _component_ElButton = _resolveComponent("ElButton")!
  const _component_ElRow = _resolveComponent("ElRow")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, { header: "Detalhes da loja" }, {
      default: _withCtx(() => [
        _createVNode(_unref(ElSkeleton), {
          loading: loading.value,
          animated: "",
          rows: 12
        }, {
          default: _withCtx(() => [
            (!store.value)
              ? (_openBlock(), _createBlock(_component_el_row, {
                  key: 0,
                  justify: "center",
                  align: "middle"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, {
                      sm: 12,
                      lg: 7
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_result, {
                          icon: "error",
                          title: "Loja não encontrada",
                          "sub-title": "A loja que procura nao existe"
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_el_descriptions, {
                    title: "Informações da Loja",
                    direction: "vertical",
                    column: 3,
                    border: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_descriptions_item, { label: "Nome" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(store.value.name), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, { label: "Tipo de produto" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(store.value.category), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, { label: "Localização" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(store.value.location), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, { label: "Contacto" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(store.value.phone), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, { label: "Email" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(store.value.email), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, { label: "Descrição" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(store.value.description), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, { label: "Dono da Loja" }, {
                        default: _withCtx(() => [
                          (store.value.user)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(store.value.user.name) + " (" + _toDisplayString(store.value.user.phone) + ") ", 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_3, " — "))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, { label: "Aprovado por" }, {
                        default: _withCtx(() => [
                          (store.value.approver)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(store.value.approver.name), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_5, " — "))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, { label: "Data de aprovação" }, {
                        default: _withCtx(() => [
                          (store.value.approved_at)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(new Date(store.value.approved_at).toLocaleString()), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_7, " Pendente "))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    plain: "",
                    loading: loading.value || updating.value,
                    type: store.value.approved_at ? 'danger':'success',
                    onClick: _cache[0] || (_cache[0] = () => approve(!(store.value?.approved_at)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElIcon), { size: 28 }, {
                        default: _withCtx(() => [
                          (store.value.approved_at)
                            ? (_openBlock(), _createBlock(_component_CircleCloseFilled, { key: 0 }))
                            : (_openBlock(), _createBlock(_component_Select, { key: 1 }))
                        ]),
                        _: 1
                      }),
                      (store.value.approved_at)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Bloquear Loja"))
                        : (_openBlock(), _createElementBlock("span", _hoisted_9, "Aprovar Loja"))
                    ]),
                    _: 1
                  }, 8, ["loading", "type"]),
                  _cache[4] || (_cache[4] = _createElementVNode("hr", null, null, -1)),
                  _cache[5] || (_cache[5] = _createElementVNode("h6", null, null, -1)),
                  _createVNode(_component_el_collapse, {
                    accordion: "",
                    class: "my-4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_collapse_item, {
                        name: "1",
                        title: "Productos da loja"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ElRow, { class: "pb-5" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ElInput, {
                                type: "search",
                                name: "q",
                                style: {"flex":"1"},
                                modelValue: search.value,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((search).value = $event)),
                                class: "mx-1",
                                placeholder: "Procurar produtos"
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_ElButton, {
                                loading: updating.value || loading.value,
                                onClick: _cache[2] || (_cache[2] = () => getProducts(search.value))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(ElIcon), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Search)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["loading"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(ElSkeleton), {
                            loading: updating.value,
                            animated: "",
                            rows: 10
                          }, {
                            default: _withCtx(() => [
                              _createVNode(ProductsList, {
                                onClickOpen: openProduct,
                                items: products.value.data.map(item => ({
                                                icon: '', 
                                                id: Number(item.id), 
                                                image: '', 
                                                title: item.name,
                                                featured: item.featured,
                                                loading: false,
                                                subtitle: `${item.quantity} unidades | ${item.price.toFixed(2).replace('.', ',')}MT`
                                            }))
                              }, null, 8, ["items"]),
                              _createVNode(_unref(ElPagination), {
                                class: "p-2",
                                "hide-on-single-page": "",
                                "default-current-page": products.value.current_page,
                                "page-count": products.value.last_page,
                                onChange: _cache[3] || (_cache[3] = (page) => getProducts(search.value, page))
                              }, null, 8, ["default-current-page", "page-count"])
                            ]),
                            _: 1
                          }, 8, ["loading"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ], 64))
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      _: 1
    })
  ]))
}
}

})